import { PropsWithChildren } from 'react';

import { Header } from '@/shared/ui';

interface ReviewDetailsCardProps {
  title?: string;
  onEdit?: () => void;
}
export const ReviewDetailsCard = ({
  children,
  title = '',
  onEdit,
}: PropsWithChildren<ReviewDetailsCardProps>) => {
  return (
    <div className="w-full rounded-3xl bg-base-300 p-4 pb-0">
      <Header
        title={title}
        titleProps={{
          color: 'default',
        }}
        action={{
          as: 'button',
          label: 'Edit',
          onClick: () => onEdit?.(),
        }}
        className="pb-4"
      />
      {children}
    </div>
  );
};
